<template>
    <div class="container bng-rules bng-narrow-container content">
        <button class="button bng-rules-close" @click="goBack"></button>
        <div class="bng-rules__wrapper">
            <div class="bng-rules__content">
                <router-view></router-view>
            </div>
            <div class="bng-rules__nav">
                <div class="bng-rules__title">{{ "components.common.basement.rules.title" | translate }}</div>
                <ul class="bng-rules__list">
                    <template v-if="rules && rules.length">
                        <li v-for="rule in rules"
                            :key="rule.contentId" class="bng-rules__item"
                        >
                            <router-link
                                :to="{name: 'rules-inner', params: { rule: rule.alias || rule.name }}"
                                class="bng-rules__link"
                            >
                                <string-content :content-ref="rule" field="title" />
                            </router-link>
                        </li>
                    </template>
                    <template v-if="lang != 'en' && enRules && enRules.length">
                        <li v-for="rule in enRules" :key="rule.contentId" class="bng-rules__item">
                            <router-link
                                :to="{name: 'rules-inner', params: { rule: rule.name }}"
                                class="bng-rules__link"
                            >
                                <string-content :content-ref="rule" field="title" />
                                <span class="has-text-weight-bold"> (EN)</span>
                            </router-link>
                        </li>
                    </template>
                    <li class="bng-rules__item">
                        <router-link
                            :to="{name: 'bonus-rules'}"
                            class="bng-rules__link"
                        >
                            <span>{{ "components.common.basement.rules.bonus-rules" | translate }}</span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

import StringContent from '../../../../../../_common/components/content/string-content.js';

export default {
    name: 'rules',
    components: { StringContent },
    data() {
        return {
            rules: null,
            enRules: null,
            previousSectionPath: '/'
        };
    },
    computed: {
        lang() {
            return Vue.state.lang.currentLang;
        },
        strings() {
            return Vue.state.content.strings.get();
        },
        firstRule() {
            if (this.rules && this.rules.length) {
                return { name: 'rules-inner', params: { rule: this.rules[0].alias || this.rules[0].name } };
            }

            return { name : 'bonus-rules' };
        }
    },
    watch: {
        lang() {
            this.reloadRules();
        }
    },
    async created() {
        await Vue.state.client.ensure();
        this.setPreviousSectionPath();
        this.reloadRules();
        this.redirect();
    },
    methods: {
        reloadRules() {
            // const { rules, enRules } = Vue.state.client.get().view.legal.allRules.reduce(
            //     (obj, rule) => {
            //         const content = Object.assign({}, rule, this.strings.find(str => str.id === rule.contentId));
            //         (content.language === this.lang) && obj.rules.push(content);
            //         (content.language === "en") && obj.enRules.push(content);
            //         return obj;
            //     },
            //     { rules: [], enRules: [] });

            // this.rules = rules;
            // this.enRules = enRules;
            const contents = Vue.state.client.get().view.legal.allRules.map(rule => {
                const str = this.strings.find(str => str.id === rule.contentId);
                return Object.assign({}, rule, str)
            });
            this.rules = contents.filter(c => c.language === this.lang);
            this.enRules = contents.filter(c => c.language === "en" && !this.rules.find(r => r.alias === c.alias));
        },
        setPreviousSectionPath() {
            const getRoute = Vue.state.route.from.get() || { name : 'index' };
            if (getRoute.name == 'rules-inner' || getRoute.name == 'bonus-rules'){
                this.previousSectionPath = '/';
            } else {
                this.previousSectionPath = getRoute;
            }
        },
        goBack() {
            this.$router.push(this.previousSectionPath);
        },
        async goToBonusRules() {
            await Vue.router.teleport.bonusRules();
        },
        redirect(){
            if (!(this.$route.params.rule || this.$route.name == 'bonus-rules')) {
                this.$router.push(this.firstRule);
            };
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/rules/rules.vue